<div class="batch-container">
  <app-section-header [title]="'Batch Processing Results'" [optionHeader]="opHeader" />
  <div class="sub-section">
    <div class="batch-toolbar">
      <button
        type="button"
        class="crm-button"
        (click)="getBatchProcessResults()"
        [disabled]="isLoading">
        Refresh
      </button>
    </div>
    <div class="batch-table-scroll">
    <app-tab-spinner *ngIf="isLoading"></app-tab-spinner>
    <p-table #dt *ngIf="admin.length > 0 || !isLoading" [columns]="cols" [value]="admin" dataKey="batchProcessingIdOriginal"
      editMode="row" sortMode="multiple" styleClass="p-datatable-gridlines batch-processing-datatable"
      [tableStyle]="{ width: '100%', 'table-layout': 'fixed' }"
      [hidden]="isLoading" [paginator]="true" [rows]="10" (onPage)="onPageChange($event)"
      (onFilter)="onFilterChange($event)">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" pResizableColumn="pResizableColumn">
            {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th class="last-cell">
            <div class="three-dots">
              <div class="icon" [inlineSVG]="'assets/three_dots.svg'"></div>
            </div>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns">
            <!-- <input class="input-text" *ngIf="col.field !== 'dEdit'" type="text"
              (input)="dt.filter($event, col.field, 'Contains')" /> -->
            <p-columnFilter *ngIf="col.field === 'fileStatus'" field="fileStatus" matchMode="contains"
              [showMenu]="false">
            </p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'fileType'" field="fileType" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'operationResults'" field="operationResults" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'dealerName'" field="dealerName" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'dealerNumber'" field="dealerNumber" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'fileName'" field="fileName" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'uploadDate'" field="uploadDate" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'planCount'" field="planCount" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'contractRange'" field="contractRange" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'dealerCost'" field="dealerCost" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'nlfTransactionDate'" field="nlfTransactionDate" matchMode="contains"
              [showMenu]="false"></p-columnFilter>
            <p-columnFilter *ngIf="col.field === 'cancellationTransactionDate'" field="cancellationTransactionDate"
              matchMode="contains" [showMenu]="false"></p-columnFilter>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <div class="crm-link" *ngIf="col.field === 'fileName'" (click)="openTab(rowData)">{{rowData[col.field]}}
            </div>
            <button *ngIf="col.type === 'status'"
              [class]="btnStatus[rowData[col.field].toLowerCase()]">{{rowData[col.field]}}</button>
            <div
              *ngIf="col.type === 'text' && col.field !== 'dealerCost' && col.field !== 'fileName' && col.field !== 'planCount' && col.field !== 'operationResults' ">
              {{rowData[col.field]}}
            </div>
            <div *ngIf="col.type === 'text' && col.field === 'operationResults'" class="operation-results-cell">
              <div *ngIf="hasOperationResultsValue(rowData.operationResults)" class="operation-results-preview">
                {{ getOperationResultsTablePreview(rowData.operationResults) }}
              </div>
              <div
                class="crm-link operation-results-link"
                (click)="openOperationResultsModal(rowData)"
                (keydown.enter)="openOperationResultsModal(rowData)"
                tabindex="0"
                role="button">
                See Results
              </div>
            </div>
            <div *ngIf="col.type === 'text' && col.field === 'dealerCost' && rowData['fileType'].toLowerCase()==='c'">
              <div class="errorText" *ngIf="getValue(rowData[col.field])!==''">{{'-$'}}{{getValue(rowData[col.field])}}
              </div>
            </div>
            <div *ngIf="col.type === 'text' && col.field === 'dealerCost' && rowData['fileType'].toLowerCase()==='s'">
              {{'$'}}{{getValue(rowData[col.field])}}
            </div>
            <div
              *ngIf="col.type === 'text' && col.field === 'extendedDealerCost' && rowData['fileType'].toLowerCase()==='s'">
              {{'$'}}{{getValue(rowData[col.field])}}
            </div>
            <div
              *ngIf="col.type === 'text' && col.field === 'planCount' && validatePositiveNumber(rowData['planCount'])">
              {{rowData[col.field]}}
            </div>
            <div
              *ngIf="col.type === 'text' && col.field === 'planCount' && !validatePositiveNumber(rowData['planCount'])">
              <div class="errorText">{{rowData[col.field]}}</div>
            </div>
            <div *ngIf="col.field === 'dEdit'">
              <div class="cAddDate" [ngClass]="{'inactive': !showAddOption(rowData)}"
                (click)="showAddOption(rowData) && openModelAdd(rowData['fileType'].toUpperCase(), rowData)">
                Add
              </div>
            </div>
          </td>
          <td class="last-cell">
            <div class="three-dots" (click)="ellipsisClick($event,rowData,op3)">
              <div class="icon" [inlineSVG]="'assets/three_dots.svg'"></div>
            </div>
          </td>
        </tr>
      </ng-template><ng-template pTemplate="footer" let-columns>
        <tr>
          <td *ngFor="let col of columns">
            <div *ngIf="col.type === 'text' && col.field === 'uploadDate'">Total Plan Count</div>
            <div *ngIf="col.type === 'text' && col.field === 'planCount'">{{planCount}}</div>
            <div *ngIf="col.type === 'text' && col.field === 'contractRange'">Total Dealer Cost</div>
            <div *ngIf="col.type === 'text' && col.field === 'dealerCost'">${{totalDealerCost}}</div>
          </td>
        </tr>
      </ng-template></p-table>
    </div>
  </div>
</div>
<p-popover #op3>
  <p-listbox [options]="ellipsisOptions" [(ngModel)]="selectedEllipsisItem"
    (onClick)="onEllipsisItemSelect($event,op3)"> </p-listbox>
</p-popover>
<p-popover #opHeader><p-listbox [options]="ellipsisMainOptions"
    (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event, opHeader) : ellipsisOptionClick($event, opHeader)"></p-listbox></p-popover><p-dialog
  [header]="title" [(visible)]="display" showeffect="fade" [modal]="true" [styleClass]="'error-dailog'"
  [blockScroll]="true">
  <div class="modal-content">
    <div class="grid">
      <div class="col-4" *ngIf="isDate">{{label}}</div>
      <div class="col-8" *ngIf="isDate">
        <input type="date" [attr.disabled]="!isApproved?true:null" [(ngModel)]="selectedDate" />
      </div>
      <div class="col-4" *ngIf="isComment">ENTER COMMENTS</div>
      <div class="col-8" *ngIf="isComment">
        <textarea name="" cols="40" rows="3" [(ngModel)]="enteredComment"> </textarea>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer" *ngIf="isApproved">
    <div class="p-dialog-buttonpane ui-helper-clearfix">
      <button class="crm-button" type="submit" (click)="onComplete()" label="ok">{{buttonLabel}}</button>
    </div>
  </ng-template>
</p-dialog>
<p-dialog
  header="Last operation results"
  [(visible)]="displayOperationResults"
  [modal]="true"
  [blockScroll]="true"
  [dismissableMask]="true"
  [style]="{ width: 'min(90vw, 42rem)' }"
  styleClass="operation-results-dialog">
  <div class="operation-results-detail" *ngIf="operationResultsModalParsed">
    <div class="operation-results-detail-row">
      <span class="operation-results-detail-label">Operation:</span>
      <span class="operation-results-detail-value">{{ getOperationTypeLabel(operationResultsModalParsed.op_type || '—') }}</span>
    </div>
    <div class="operation-results-detail-row">
      <span class="operation-results-detail-label">Status:</span>
      <span class="operation-results-detail-value">{{ operationResultsModalParsed.op_status || '—' }}</span>
    </div>
    <div class="operation-results-detail-row">
      <span class="operation-results-detail-label">Note:</span>
      <span class="operation-results-detail-value">{{ operationResultsModalParsed.op_notes || '—' }}</span>
    </div>
    <div
      class="operation-results-detail-row"
      *ngIf="hasOperationResultsContractsNumbers(operationResultsModalParsed)">
      <span class="operation-results-detail-label">Details:</span>
      <span class="operation-results-detail-value">{{
        formatOperationResultsContractsNumbers(operationResultsModalParsed)
      }}</span>
    </div>
  </div>
  <div class="operation-results-detail-empty" *ngIf="!operationResultsModalParsed">
    No operation results available.
  </div>
  <ng-template pTemplate="footer">
    <button class="crm-button" type="button" (click)="displayOperationResults = false">Close</button>
  </ng-template>
</p-dialog>